'use client';

import { useRouter } from 'next/navigation';
import { usePageLoader } from './usePageLoader';
import { Route } from 'next';
import { NavigateOptions } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import React from 'react';

/**
 * next/navigationのuseRouterをカスタマイズしたカスタムフック
 * 画面遷移時にローディングを表示したいときにお使いください
 */
export const useNextRouter = () => {
  const router = useRouter();
  const { setLoading } = usePageLoader();
  const [isRouterPending, startRouterTransition] = React.useTransition();

  const push = (url: Route, option?: NavigateOptions) => {
    startRouterTransition(() => {
      router.push(url, option);
    });
  };

  const refresh = () => {
    startRouterTransition(() => {
      router.refresh();
    });
  };

  const back = () => {
    startRouterTransition(() => {
      router.back();
    });
  };

  const forward = () => {
    startRouterTransition(() => {
      router.forward();
    });
  };

  React.useEffect(() => {
    setLoading(isRouterPending);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRouterPending]);

  return { push, refresh, back, forward };
};
